import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type MetricsService from 'garaje/services/metrics';
import type PageVisibilityTrackerService from 'garaje/services/page-visibility-tracker';

export default class ManageEventLogRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare metrics: MetricsService;
  @service declare pageVisibilityTracker: PageVisibilityTrackerService;

  titleToken = 'Event Log';

  private sessionId = 'local-event-log';

  beforeModel(): void {
    if (this.abilities.cannot('visit local event log in manage-settings')) {
      this.router.transitionTo('unauthorized');
    }
  }

  afterModel(): void {
    this.metrics.trackPage('Local Event Log Page', {
      context: 'local_event_log',
      page_type: 'event_log',
      scope: 'location',
    });

    this.pageVisibilityTracker.startTracking(
      this.sessionId,
      'local_event_log',
      'location',
      'Event Log Page Time Spent',
    );
  }

  deactivate(): void {
    this.pageVisibilityTracker.stopTracking(this.sessionId);
  }
}
